import { Button, ButtonGroup } from "@chakra-ui/react";
import { LoanFieldModel } from "providers/loans/loan-field.model";
import { useEffect, useState } from "react";

export enum LoanApplicationToogleOptions {
  Application = "application",
  Loan = "loan",
}

const LoanApplicationToogleButton = ({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) => {
  return (
    <Button
      width="170px"
      height="30px"
      borderColor={active ? "primary" : "#E4E3E6"}
      color={active ? "primary" : "gray.300"}
      backgroundColor={active ? "#F4F4F4" : "white"}
      zIndex={active ? 1 : 0}
      fontWeight="500"
      onClick={onClick}
      _hover={{
        backgroundColor: "#E4E3E6",
      }}
    >
      {label}
    </Button>
  );
};

type LoanApplicationToogleProps = {
  activeTab?: LoanApplicationToogleOptions;
  onChange: (tab: LoanApplicationToogleOptions) => void;
  applicationTerm?: string;
};

export function LoanApplicationToogle({
  activeTab = LoanApplicationToogleOptions.Application,
  onChange,
  applicationTerm = "Application",
}: LoanApplicationToogleProps) {
  const [activeTabState, setActiveTabState] = useState<LoanApplicationToogleOptions>(activeTab);

  useEffect(() => {
    setActiveTabState(activeTab);
  }, [activeTab]);

  const handleTabChange = (tab: LoanApplicationToogleOptions) => {
    setActiveTabState(tab);
    onChange(tab);
  };

  return (
    <ButtonGroup isAttached variant="outline">
      <LoanApplicationToogleButton
        label={applicationTerm}
        active={activeTabState === LoanApplicationToogleOptions.Application}
        onClick={() => handleTabChange(LoanApplicationToogleOptions.Application)}
      />
      <LoanApplicationToogleButton
        label="Loan"
        active={activeTabState === LoanApplicationToogleOptions.Loan}
        onClick={() => handleTabChange(LoanApplicationToogleOptions.Loan)}
      />
    </ButtonGroup>
  );
}

export function ApplyFilterTo(
  userType: string,
  options: LoanApplicationToogleOptions,
  field: LoanFieldModel
) {
  if (userType === "lender") {
    switch (options) {
      case LoanApplicationToogleOptions.Application:
        return field.show_on_lender_application;
      case LoanApplicationToogleOptions.Loan:
        return field.show_on_lender_loan;
    }
  } else if (userType === "borrower") {
    switch (options) {
      case LoanApplicationToogleOptions.Application:
        return field.show_on_borrower_application;
      case LoanApplicationToogleOptions.Loan:
        return field.show_on_borrower_loan;
    }
  }

  return true;
}
